import { render, staticRenderFns } from "./Cartera.vue?vue&type=template&id=0dab299a"
import script from "./Cartera.vue?vue&type=script&lang=js"
export * from "./Cartera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports